<template>
  <div>
    <div class="card card-custom gutter-b example example-compact">
      <div class="card-header">
        <div class="card-title">
          <h3>Newsletters</h3>
        </div>
        <!-- <div class="card-toolbar">
          <v-btn
            class="px-7 py-3 font-size-3 text-white invite-btn"
            @click="goToAddNew"
          >
            <b-icon
              icon="plus-circle-fill"
              scale="1"
              aria-hidden="true"
              variant="light"
              class="mr-2"
            ></b-icon>
            Neu hinzufügen
          </v-btn>
        </div> -->
      </div>
      <div class="card-body">
        <div class="text-right">
          <download-csv
            class="download-csv-btn"
            v-if="jsonData.length"
            :separator-excel="true"
            :data="jsonData"
            name="gustoreich-newsletters.csv"
          >
            <v-btn class="no-button"> Download Newsletters </v-btn>
            <!-- <img src="download_icon.png" /> -->
          </download-csv>
        </div>
        <div class="table-responsive mt-5">
          <v-simple-table class="record-table">
            <thead>
              <tr>
                <th class="text-center align-middle" width="10%">
                  Seriennummer
                </th>
                <th
                  class="text-center align-middle"
                  @click="
                    sortListing(
                      'first_name',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  "
                >
                  Name
                  <span class="tbl-sort-icons ml-2">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'first_name'"
                    ></i>
                    <i
                      class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'first_name' && filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'first_name' && filter.orderBy === 'desc'
                      "
                    ></i>
                  </span>
                </th>
                <th
                  class="text-center align-middle"
                  @click="
                    sortListing(
                      'email',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  "
                >
                  E-Mail
                  <span class="tbl-sort-icons ml-2">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'email'"
                    ></i>
                    <i
                      class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'email' && filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'email' && filter.orderBy === 'desc'
                      "
                    ></i>
                  </span>
                </th>
                <th class="text-center align-middle">Telefonnummer</th>
                <th class="text-center align-middle">Geschlecht</th>
                <th class="text-center align-middle">Registrierung</th>
                <th class="text-center align-middle" width="15%">Aktionen</th>
              </tr>
            </thead>
            <tr>
              <td></td>
              <td>
                <div>
                  <div class="search-input-div">
                    <v-text-field
                      dense
                      autocomplete="new-password"
                      v-model.lazy="searchNameKey"
                      solo
                      label="Name suchen..."
                      clearable
                    ></v-text-field>
                  </div>
                </div>
              </td>
              <td>
                <div class="search-input-div">
                  <v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchEmailKey"
                    solo
                    label="E-Mail suchen..."
                    clearable
                  ></v-text-field>
                </div>
              </td>
              <td>
                <div class="search-input-div">
                  <v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchPhoneKey"
                    solo
                    label="Telefonnummer suchen..."
                    clearable
                  ></v-text-field>
                </div>
              </td>
              <td>
                <div class="search-input-div">
                  <v-select
                    :items="genderItems"
                    v-model="searchGenderKey"
                    item-text="title"
                    item-value="value"
                    label="Geschlecht suchen..."
                    solo
                    clearable
                  />
                </div>
              </td>
              <td></td>
            </tr>
            <tbody v-if="newsletters.length">
              <tr v-for="(newsletter, i) in newsletters" :key="newsletter.id">
                <td class="align-middle">
                  {{ i + 1 }}
                </td>
                <td class="align-middle">
                  {{ newsletter.first_name + " " + newsletter.last_name }}
                </td>
                <td class="align-middle">
                  {{ newsletter.email }}
                </td>
                <td class="align-middle">
                  {{ newsletter.mobile_no ? newsletter.mobile_no : "-" }}
                </td>
                <td class="align-middle">
                  {{ newsletter.gender ? newsletter.gender : "-" }}
                </td>
                <td class="align-middle">
                  {{ newsletter.register_date ? newsletter.register_date : '' }}
                </td>
                <td
                  class="align-middle text-center icon-wrapper-block"
                  width="15%"
                >
                  <a @click="deleteNewsletter(newsletter.id)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="trash"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Löschen</span>
                    </v-tooltip>
                  </a>
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="loading_newsletters" class="loading-tbody">
              <td colspan="10">
                Wird geladen...
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
              </td>
            </tbody>
            <tbody v-else class="loading-tbody">
              <tr>
                <td colspan="10">Keine Einträge gefunden</td>
              </tr>
            </tbody>
          </v-simple-table>
          <div class="d-flex pagination-block">
            <b-pagination
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total-rows="pagination.paginationRows"
              prev-text="Voriges"
              next-text="Nächstes"
              first-number
              last-number
              @change="paginationChange"
            >
              <template #prev-text
                ><span
                  ><b-icon
                    icon="chevron-left"
                    aria-hidden="true"
                    rel="prev"
                  ></b-icon></span
              ></template>
              <template #next-text
                ><span
                  ><b-icon
                    icon="chevron-right"
                    aria-hidden="true"
                    rel="next"
                  ></b-icon></span
              ></template>
            </b-pagination>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="showFileModal" scroll="false" max-width="600px">
      <v-card>
        <v-card-title>
          <v-btn class="image-close-btn" text @click="showFileModal = false">
            <i data-v-cddd0c2e="" class="ki ki-close icon-xs text-white"></i>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="modalFile">
            <div>
              <b-img :src="modalFile" class="modal-image"></b-img>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="statusDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Bitte bestätigen
        </v-card-title>

        <v-card-text>
          <span>Wollen Sie den Status wirklich ändern?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            Nein
          </v-btn>
          <v-btn
            type="submit"
            @click="changeStatusRecord(statusRecordId, newStatus)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Bitte bestätigen
        </v-card-title>

        <v-card-text>
          <span>Wollen Sie den Eintrag wirklich löschen?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            Nein
          </v-btn>
          <v-btn
            type="submit"
            @click="deleteRecord(deleteRecordId)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <notifications group="newsletters" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Notifications from "vue-notification";
import Loader from "@/components/admin/layout/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import adminAPI from "@/api/admin";
import JsonCSV from "vue-json-csv";

Vue.component("downloadCsv", JsonCSV);

Vue.use(Notifications);

export default {
  name: "Newsletters",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.userId = localStorage.getItem("local_products_user_access_id");
      this.getNewsletters();
      this.getAllNewsletters();
    }
  },
  mounted() {
    document.body.classList.add("no-scroll");
  },

  destroyed() {
    document.body.classList.remove("no-scroll");
  },
  data() {
    return {
      loading_newsletters: true,
      filter: {
        orderCol: "id",
        orderBy: "desc",
      },
      searchKey: "",
      userId: null,
      showFileModal: false,
      modalFile: null,
      showDeleteModal: false,
      deleteRecordId: null,
      showStatusModal: false,
      statusRecordId: null,
      yesActionLoading: false,
      disabledCancel: false,
      statusDialog: false,
      deleteDialog: false,
      newStatus: null,
      searchNameKey: "",
      searchEmailKey: "",
      searchPhoneKey: "",
      newsletters: [],
      jsonData: [],
      searchGenderKey: "",
      genderItems: [
        {
          title: "Männlich",
          value: "Männlich",
        },
        {
          title: "Weiblich",
          value: "Weiblich",
        }
      ],
      pagination: {
        currentPage: 1,
        perPage: 20,
        paginationRows: "",
      },
    };
  },
  components: {},
  watch: {
    searchNameKey: {
      handler: function (val, oldVal) {
        this.newsletters = [];
        this.loading_newsletters = true;
        this.getNewsletters();
      },
      deep: true,
    },
    searchEmailKey: {
      handler: function (val, oldVal) {
        this.newsletters = [];
        this.loading_newsletters = true;
        this.getNewsletters();
      },
      deep: true,
    },
    searchPhoneKey: {
      handler: function (val, oldVal) {
        this.newsletters = [];
        this.loading_newsletters = true;
        this.getNewsletters();
      },
      deep: true,
    },
    searchGenderKey: {
      handler: function (val, oldVal) {
        this.orders = [];
        this.loading_orders = true;
        this.getNewsletters();
      },
      deep: true,
    },
  },
  methods: {
    goToEdit(id) {
      this.$router.push({ path: "/admin/edit-newsletter/" + id });
    },
    hideModal() {
      this.statusDialog = false;
      this.yesActionLoading = false;
      this.deleteDialog = false;
    },
    goToAddNew() {
      this.$router.push({ name: "add-newsletter" });
    },
    sortListing(orderCol, orderBy) {
      if (!this.loading_newsletters) {
        this.newsletters = [];
        this.filter.orderCol = orderCol;
        this.filter.orderBy = orderBy;
        this.pagination.currentPage = 1;
        this.loading_newsletters = true;
        this.getNewsletters();
      }
    },
    openFileModal(file) {
      this.showFileModal = true;
      this.modalFile = file;
    },
    paginationChange() {
      this.newsletters = [];
      this.loading_newsletters = true;
      setTimeout(() => {
        this.getNewsletters();
      }, 100);
    },
    getNewsletters() {
      let data = {
        user_id: this.currentUser.id,
        page: this.pagination.currentPage,
        search_name_field: this.searchNameKey,
        search_email_field: this.searchEmailKey,
        search_phone_field: this.searchPhoneKey,
        per_page: this.pagination.perPage,
        sort_column: this.filter.orderCol,
        search_gender_field: this.searchGenderKey,
        sort_type: this.filter.orderBy,
      };
      adminAPI
        .getNewsletters(data)
        .then((response) => {
          if (response.status == "success") {
            this.newsletters = response.data;
            this.pagination.paginationRows = response.count;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_newsletters = false;
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_newsletters = false;
            this.$notify({
              group: "newsletters",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.loading_newsletters = false;
          this.$notify({
            group: "newsletters",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    getAllNewsletters() {
      let data = {
        user_id: this.currentUser.id,
      };
      adminAPI
        .getAllNewsletters(data)
        .then((response) => {
          if (response.status == "success") {
            this.jsonData = response.data;
          } else {
            this.$notify({
              group: "newsletters",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.loading_newsletters = false;
          this.$notify({
            group: "newsletters",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    deleteNewsletter(id) {
      this.deleteDialog = true;
      this.deleteRecordId = id;
    },
    deleteRecord(id) {
      this.disabledCancel = true;
      this.yesActionLoading = true;
      adminAPI
        .deleteNewsletter({ id: id })
        .then((response) => {
          if (response.status == "success") {
            this.deleteDialog = false;
            this.deleteRecordId = null;
            this.disabledCancel = false;
            this.yesActionLoading = false;
            this.$notify({
              group: "newsletters",
              type: "success",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
            this.pagination.currentPage = 1;
            this.getNewsletters();
          } else {
            this.deleteDialog = false;
            this.deleteRecordId = null;
            this.disabledCancel = false;
            this.yesActionLoading = false;
            this.$notify({
              group: "newsletters",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.deleteDialog = false;
          this.deleteRecordId = null;
          this.disabledCancel = false;
          this.yesActionLoading = false;
          this.$notify({
            group: "newsletters",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },

    changeStatus(id, status) {
      if (status == 0) {
        this.newStatus = "1";
      } else {
        this.newStatus = "0";
      }
      this.statusDialog = true;
      this.statusRecordId = id;
    },
    changeStatusRecord(id, status) {
      this.yesActionLoading = true;
      this.disabledCancel = true;

      adminAPI
        .statusnewsletter({ id: id, status: status })
        .then((response) => {
          if (response.status == "success") {
            this.statusDialog = false;
            this.statusRecordId = null;
            this.newStatus = null;
            this.yesActionLoading = false;
            this.disabledCancel = false;
            this.$notify({
              group: "newsletters",
              type: "success",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
            this.getNewsletters();
          } else {
            this.statusDialog = false;
            this.statusRecordId = null;
            this.newStatus = null;
            this.yesActionLoading = false;
            this.disabledCancel = false;
            this.$notify({
              group: "newsletters",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.statusDialog = false;
          this.statusRecordId = null;
          this.newStatus = null;
          this.yesActionLoading = false;
          this.disabledCancel = false;
          this.$notify({
            group: "newsletters",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>

<style scoped>
table {
  text-align: center;
  font-size: 15px;
}

.new-btn-text {
  margin-left: 10px;
  font-size: 13px;
}

a {
  cursor: pointer;
}

.file-modal {
  padding: 0;
  margin: 0;
}

.modal-image {
  width: 100%;
}

.table-image {
  cursor: pointer;
  margin: 5px;
}

th {
  cursor: pointer;
}

.loading-tbody {
  text-align: center;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  height: 48px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 14px;
  height: 48px;
}

.clickable-td {
  cursor: pointer;
}
</style>